<template>
  <div class="article">
    <div class="img-article">
      <b-skeleton-img />
    </div>
    <div class="article-content">
      <div>
        <h2 class="title">
          <b-skeleton animation="wave" width="100%" height="25px"></b-skeleton>
        </h2>
        <p class="description">
          <b-skeleton animation="wave" width="100%" height="20px"></b-skeleton>
          <b-skeleton animation="wave" width="50%" height="20px"></b-skeleton>
          <b-skeleton
            class="mt-2"
            animation="wave"
            width="25%"
            height="20px"
          ></b-skeleton>
        </p>
      </div>
      <div class="article-foot">
        <div class="author">
          <b-skeleton type="avatar" />
          <b-skeleton animation="wave" width="80px" height="17px"></b-skeleton>
        </div>
        <div class="actions">
          <b-skeleton animation="wave" width="70px" height="17px"></b-skeleton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "ArticleSecondSkeleton"
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.ico-share {
  position: relative;
  cursor: pointer;

  svg:hover {
    transform: scale(1.07);
  }
}
.ico-bookmark {
  cursor: pointer;
  &:hover {
    transform: scale(1.07);
  }
}
.share-popup {
  position: absolute;
  width: 150px;
  height: 40px;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  bottom: 100%;
  right: 80%;
  z-index: 3;
  .ico-bookmark {
    cursor: pointer;
  }
}
.article {
  display: grid;
  grid-template-columns: 198px 1fr;
  grid-column-gap: 23px;
  margin-bottom: 24px;
  align-items: stretch;
  .img-article {
    width: 198px;
    height: 100%;
    & > div {
      height: 100%;
    }
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
}
.article-content {
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #52595e;
    margin-bottom: 8px;
  }
  .description {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #8d99a0;
    margin-bottom: 8px;
  }
  .details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .read-more-btn {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: right;
      color: #557efb;
    }
    .categories {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      grid-column-gap: 8px;
      .read {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
  }
  .article-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .author {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      grid-column-gap: 12px;
      img {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .actions {
      display: flex;
      justify-content: center;
      align-items: center;
      grid-column-gap: 16px;
    }
  }
}
@media (max-width: 991px) and (min-width: 767px) {
  .article {
    grid-template-columns: 1fr;
    .img-article {
      margin: 20px auto;
      height: 138px;
    }
  }
}

@media (max-width: 677px) {
  .article {
    grid-template-columns: 1fr;
    .img-article {
      margin: 20px auto;
      height: 138px;
    }
  }
}
</style>
